import React from "react"
import styled from "styled-components"

import {FormattedMessage} from "@irati/utils/lang"
import {Hr} from "@irati/ui/src/Layout"
import Flex from "@irati/ui/src/Flex"
import {Body} from "@irati/ui/src/Typography"
import appOnly from "@irati/ui/images/app_only.svg"

const Container = styled.div`
  width: 100%;
`

const Image = styled.img`
  height: 30px;
`

interface Props {
  id?: string
}

const AppOnly: React.FC<Props> = () => {
  return (
    <Container>
      <Hr />
      <Flex alignItems="center" marginTop={2}>
        <Image src={appOnly} />
        <Body weight="bold" margin={[0, 0, 0, 1]}>
          <FormattedMessage id="perks.appOnlyImportantInfo.header" />
        </Body>
      </Flex>
      <Body small margin={[2, 0]}>
        <FormattedMessage id="perks.appOnlyImportantInfo.subHeader" />
      </Body>
    </Container>
  )
}

export default AppOnly
